import { tempURL, apiURL, localURL, awsUrl } from "../config";
import { setCookie } from "./session_data";
import { Auth } from "./amplifyAuth.js";
import axios from "axios";
import $ from "jquery";
import { getUserAuthStatus, showErrAlert } from "./common";
import { awsUrl2 } from "../config";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
window.jQuery = $;
window.$ = $;
globalThis.jQuery = $;
require("bootstrap");

function getBrowser() {
  const userAgent = navigator.userAgent;
  if (/Edg\//i.test(userAgent)) {
    return "Edge";
  }
  if (/Chrome/i.test(userAgent) && !/Edg\//i.test(userAgent)) {
    return "Chrome";
  }
  if (/Firefox/i.test(userAgent)) {
    return "Firefox";
  }
  if (
    /Safari/i.test(userAgent) &&
    !/Chrome/i.test(userAgent) &&
    !/Edg\//i.test(userAgent)
  ) {
    return "Safari";
  }
  if (/MSIE/i.test(userAgent) || /Trident/i.test(userAgent)) {
    return "Internet Explorer";
  }
  return "Unknown Browser";
}


export async function signIn(e) {
  e.preventDefault();
  let validForm = validateForm();
  if (validForm) {
    $("#loader").css("display", "block");
    const username = $("#userId").val();
    const password = $("#userPassword").val();
    try {
      var userTemp = await Auth.signIn(username.toLowerCase(), password);
      let visitorId = null;
      let browser = null;
      try {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        visitorId = result.visitorId;
        browser = getBrowser();
      } catch (fpError) {
        console.error("Error collecting fingerprint:", fpError);
        visitorId = "fingerprint-unavailable";
        browser = "browser-detection-failed";
      }
      if (userTemp.signInUserSession !== null) {
        let clientrole = userTemp.signInUserSession.accessToken.payload["cognito:groups"].includes(process.env.REACT_APP_ADMIN_GROUP) 
        ? "admin" 
        : userTemp.signInUserSession.accessToken.payload["cognito:groups"].includes(process.env.REACT_APP_AGENT_GROUP)
          ? "agent"
          : userTemp.signInUserSession.accessToken.payload["cognito:groups"].includes(process.env.REACT_APP_UW_GROUP)
            ? "UW"
            : "unknown";
        const userData = {
          email_id: username.toLowerCase(),
          stage: process.env.REACT_APP_MODE,
          client: "Fuba",
          clientrole: clientrole,
          browser: browser,
          fp_uniqueid: visitorId,
        }
        try {
          await axios.post(awsUrl2 + "/api/trackUserSession", userData)
          console.log("UserSessionManagement table is updated")
        } catch (error) {
          console.log("Error in updating the UserSessionManagement table")
        }
      }

      console.log("UserTemp: ", userTemp);
      if (userTemp.challengeName === "NEW_PASSWORD_REQUIRED") {
        $("#link").click();
        $("#loader").css("display", "none");
      } else {
        if (
          userTemp.signInUserSession !== null &&
          userTemp.signInUserSession.accessToken.payload[
            "cognito:groups"
          ].includes(process.env.REACT_APP_ADMIN_GROUP)
        ) {
          console.log(
            "User Role",
            userTemp.signInUserSession.accessToken.payload["cognito:groups"]
          );
          sessionStorage.setItem("isLoggedIn", true);
          window.location.href = "./AdminDashboard";
          $("#loader").css("display", "none");
        } else if (
          userTemp.signInUserSession !== null &&
          userTemp.signInUserSession.accessToken.payload[
            "cognito:groups"
          ].includes(process.env.REACT_APP_AGENT_GROUP)
        ) {
          console.log(
            "User Role",
            userTemp.signInUserSession.accessToken.payload["cognito:groups"]
          );
          sessionStorage.setItem("isLoggedIn", true);
          window.location.href = "./AgentDashboard";
          $("#loader").css("display", "none");
        } else if (
          userTemp.signInUserSession !== null &&
          userTemp.signInUserSession.accessToken.payload[
            "cognito:groups"
          ].includes(process.env.REACT_APP_UW_GROUP)
        ) {
          console.log(
            "User Role",
            userTemp.signInUserSession.accessToken.payload["cognito:groups"]
          );
          sessionStorage.setItem("isLoggedIn", true);
          window.location.href = "./UWDashboard";
          $("#loader").css("display", "none");
        }
        // else if (
        //   userTemp.signInUserSession !== null &&
        //   userTemp.signInUserSession.accessToken.payload[
        //     "cognito:groups"
        //   ].includes(process.env.REACT_APP_SALES_GROUP)
        // ) {
        //   let user_email_id = userTemp.username;
        //   sessionStorage.setItem("isLoggedIn", true);
        //   sessionStorage.setItem("otpVerified", true);
        //   window.location.href = "./SalesDashboard";
        // } else if (
        //   userTemp.signInUserSession !== null &&
        //   (userTemp.signInUserSession.accessToken.payload[
        //     "cognito:groups"
        //   ].includes("Compliance") ||
        //     userTemp.signInUserSession.accessToken.payload[
        //       "cognito:groups"
        //     ].includes("ComplianceAdmin"))
        // ) {
        //   // let user_email_id = userTemp.username;
        //   sessionStorage.setItem("isLoggedIn", true);
        //   window.location.href = "./PanelCompliance";
        // } else if (
        //   userTemp.signInUserSession !== null &&
        //   userTemp.signInUserSession.accessToken.payload[
        //     "cognito:groups"
        //   ].includes(process.env.REACT_APP_PREUW_GROUP)
        // ) {
        //   sessionStorage.setItem("isLoggedIn", true);
        //   window.location.href = "./PanelUW";
        // }
        else {
          Auth.signOut()
            .then(function(res) {})
            .catch((err) => {
              console.log("error in logout: ", err);
            });
          let errMsg;
          $("#loader").css("display", "none");
          errMsg = "User does not exist!";
          $("#loginSubmit")
            .siblings(".errMsg")
            .html("<br /> " + errMsg);
        }
        console.log("In loged in page: ", userTemp);
      }
    } catch (err) {
      let errMsg;
      $("#loader").css("display", "none");
      console.log("error signing in! :", err);
      if (
        err.code === "UserNotFoundException" ||
        err.code === "NotAuthorizedException"
      ) {
        errMsg = err.message;
      } else {
        errMsg =
          "Unable to login! Please contact admin@insurecomp.com for more details!";
      }
      $("#loginSubmit")
        .siblings(".errMsg")
        .html("<br /> " + errMsg);
    }
  }
}

function validateForm() {
  var form = true;
  if (
    $("#userId").val() === "" ||
    document.getElementById("userId").style.borderColor === "red"
  ) {
    $("#userId").css("border-color", "rgb(255, 0, 0)");
    $("#userId")
      .siblings(".errMsg")
      .html("Email is required");
    $("#userId").focus();
    form = false;
  }
  if (
    $("#userPassword").val() === "" ||
    document.getElementById("userId").style.borderColor === "red"
  ) {
    $("#userPassword").css("border-color", "rgb(255, 0, 0)");
    $("#userPassword")
      .siblings(".errMsg")
      .html("Password is required");
    $("#userPassword").focus();
    form = false;
  }
  return form;
}
